import { render, staticRenderFns } from "./Jamlash.vue?vue&type=template&id=f8d87404&scoped=true"
import script from "./Jamlash.vue?vue&type=script&lang=js"
export * from "./Jamlash.vue?vue&type=script&lang=js"
import style0 from "./Jamlash.vue?vue&type=style&index=0&id=f8d87404&prod&lang=scss&scoped=true"
import style1 from "./Jamlash.vue?vue&type=style&index=1&id=f8d87404&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d87404",
  null
  
)

export default component.exports